export const guides = [
    { title: "Facts", description: "Symptoms, medical history, and your current condition." },
    { title: "Feelings", description: "Concerns or thoughts about your symptoms and your condition." },
    { title: "Fears", description: "Impact of your condition on your daily life" },
    { title: "Future", description: "Expectations, hopes, and goals you have for the future" },
  ];
